import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andrew Laws
 * id DC51467E-30C0-4144-9AE6-80762ACA972C
 * name magazine-pistol
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magazine-pistol.svg
 * tags
 */
export const MagazinePistolIcon = createSvgIcon(<><path d="M14 1L12 3H7L9 21H8V23H18V21L16 1M9 5H12L12.24 7H9.24M9.47 9H12.47L12.71 11H9.71M9.94 13H12.94L13.18 15H10.18M10.41 17H13.41L13.65 19H10.65Z" /></>, 'MagazinePistolIcon');
export default MagazinePistolIcon